/**
 * Error codes the API returns when a delete is refused because an image is hero or carousel on an active PDP.
 *
 * - `IMAGE_IN_ACTIVE_PDP` — one image. From a collection or the Asset Library the whole Spark tree is deleted, so a
 *                           Spark variant made from the image blocks it too. From a PDP only the image itself counts.
 * - `COLLECTION_CONTAINS_ACTIVE_IMAGES` — a whole collection, when any of its images or their Spark variants is active.
 */
export const ACTIVE_PDP_ERROR_CODES = {
  image: 'IMAGE_IN_ACTIVE_PDP',
  collection: 'COLLECTION_CONTAINS_ACTIVE_IMAGES',
} as const;

const IN_USE_ONE = 'used as a hero or carousel image on a product page';
const IN_USE_MANY = 'used as hero or carousel images on product pages';

/**
 * Why a delete was refused, for the failure toasts. No trailing period, so callers can add to the sentence. Covers Spark
 * variants, so don't use them for a delete from a PDP.
 */
export const ACTIVE_PDP_DELETE_REASONS = {
  image: `This image, or a Spark image made from it, is ${IN_USE_ONE}`,
  images: (count: number) =>
    count === 1
      ? `1 image, or a Spark image made from it, is ${IN_USE_ONE}`
      : `${count} images, or Spark images made from them, are ${IN_USE_MANY}`,
  collection: `Some images in this collection, or Spark images made from them, are ${IN_USE_MANY}`,
};
